import * as React from 'react'
import { Col, Row, ButtonToolbar, Button, ButtonGroup} from 'reactstrap';
import $ from 'jquery'
import { accentUtils, format, from, showDialog, t } from '../../services/HelperService';
import { AccentButton } from '../AccentButton';
import { AccentSpinner } from '../AccentSpinner';
import { queryNoTracking, update } from '../../services/DataService';
import { showWizardModel } from '../../wizards/RTLWizard';
import newLeadWizardModel, { NewLeadWizardData } from '../../wizards/NewLeadWizard';
import { showDiscardWebLeadDlg } from '../../dialogs/DiscardWebLeadDlg';
import { ExternalLeadGrid } from '../../grids/ExternalLeadGrid';
import { isMobileOnly } from 'react-device-detect';
import { SnoozeDlg } from '../../dialogs/SnoozeDlg';


let lastSnoozeShow = false;

const query_NewLead_LoadContact = queryNoTracking("NewLead_LoadContact");
const query_Views_Opportunities_LeadMatches = queryNoTracking("Views_Opportunities_LeadMatches");
const query_Views_Opportunities_WebLeads = queryNoTracking("Views_Opportunities_WebLeads", undefined, true);


export function getCustomProperties(leadDataObj) {

    var customProperties = [];

    if (!accentUtils.isNull(leadDataObj.CustomProperties)) {

        for (var p in leadDataObj.CustomProperties) {

            customProperties.push({
                Name: p,
                Value: leadDataObj.CustomProperties[p]
            });
        }
    }


    return customProperties;
}

export class RTLContactMatchResult extends React.Component {

    constructor(props) {
        super(props);

        

        this.getMatchClassName = this.getMatchClassName.bind(this);

    }


    getMatchClassName(isMatch) {

        if (isMatch)
            return "leads-fld-match";

        return "leads-fld";
    }

    render() {

        var me = this;

        var m = this.props.model;


        var fullName = m.FirstName + ' ' + m.LastName;
        //var address = m.AddressLines + ', ' + m.City + ', ' + m.State + ', ' + m.Country;

        return <Row>
            <Col md="12" className="webLeads-match">
                <Row>
                    <Col md="12">
                        <div className="d-flex justify-content-between">
                            <div>
                                <span className={me.getMatchClassName(m.NameMatched || m.NamePartialMatched)}>{fullName}</span>
                            </div>
                            <div>
                                <AccentButton className="float-right" tagName="existingWebLead" onClick={function () { me.props.onSelect(m.ID); }}>{t(this.props.selectTitle)}</AccentButton>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <div className="d-flex flex-column">
                            <div className="d-flex">
                                <div style={{ minWidth: "30px" }}>e:</div>
                                <div><span className={me.getMatchClassName(m.EmailMatched)}>{m.Email}</span></div>
                            </div>
                            <div className="d-flex">
                                <div style={{ minWidth: "30px" }}>m:</div>
                                <div><span className={me.getMatchClassName(m.MobileMatched)}>{m.Mobile}</span></div>
                            </div>
                            <div className="d-flex">
                                <div style={{ minWidth: "30px" }}>w:</div>
                                <div><span className={me.getMatchClassName(m.WorkPhoneMatched)}>{m.WorkPhone}</span></div>
                            </div>
                            <div className="d-flex">
                                <div style={{ minWidth: "30px" }}>h:</div>
                                <div><span className={me.getMatchClassName(m.HomePhoneMatched)}>{m.HomePhone}</span></div>
                            </div>
                        </div>
                    </Col>                    

                </Row>
                <Row>
                    <Col md="12">
                        <div className="d-flex justify-content-between">
                            <div>
                                <span className={me.getMatchClassName(false)}>{m.AddressLines}</span>
                            </div>
                            <div>
                                <span className={me.getMatchClassName(false)}>{m.Postcode}</span>
                            </div>
                            <div>
                                <span className={me.getMatchClassName(false)}>{m.State}</span>
                            </div>
                            <div>
                                <span className={me.getMatchClassName(false)}>{m.Country}</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>;
    }
}



export class WebLeadCtrl extends React.Component {

    constructor(props) {
        super(props);


        this.gridCtrl = React.createRef();

        this.state = {
            active: null,
            matchData: null
        };


        this.dataKey = 0;

        this.useExisting = this.useExisting.bind(this);
        this.newLead = this.newLead.bind(this);
        this.discardLead = this.discardLead.bind(this);
        this.snoozeLead = this.snoozeLead.bind(this);
        this.loadMatchData = this.loadMatchData.bind(this);
        this.getMatchClassName = this.getMatchClassName.bind(this);
        this.getCustomPropertiesNotes = this.getCustomPropertiesNotes.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.showSnoozeDialog = this.showSnoozeDialog.bind(this);
        this.applyWake = this.applyWake.bind(this);
        this.toggleShowSnooze = this.toggleShowSnooze.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.getActions = this.getActions.bind(this);
        this.getQuery = this.getQuery.bind(this);
        this.onGridRefresh = this.onGridRefresh.bind(this);
        
    }




    showSnoozeDialog() {

        var me = this;

        showDialog(<SnoozeDlg title="application_strings.views.leads.leadGrid.snooze" settingsKey="web-leads" showNotes />).then(e => {
            if (!e.canceled) {                
                update("SnoozeExternalLead", { ID: me.state.active.ID, SnoozeDate: e.date.toISOString(), Notes: e.notes }).then(r => {
                    me.gridCtrl.current.refresh();
                });
            }
        });
    }

    applyWake() {
        var me = this;
        update("WakeExternalLead", { ID: me.state.active.ID, SnoozeDate: null }).then(r => {
            me.gridCtrl.current.refresh();
        });
    }

    getCustomPropertiesNotes(lead) {
        var leadData = JSON.parse(lead.LeadData)

        var curstProps = getCustomProperties(leadData);

        var props = from(curstProps).select(p => "{0}: {1}".format(p.Name, p.Value)).toArray();

        return props.join('\n');

    }

    newLead() {

        
        if (!accentUtils.isNull(this.state.active)) {

            var lead = this.state.active;


            var webLeadData = JSON.parse(lead.LeadData);
            var leadAddress = webLeadData.Address || {};
            var data = new NewLeadWizardData({ WebLead: { ExternalLeadID: lead.ID, ExternalLeadDate: lead.Date, ...webLeadData, CostcoLeadID: lead.CostcoLeadID } });

            data.setBillingContact({
                FirstName: webLeadData.ContactFirstName,
                LastName: webLeadData.ContactLastName,
                Email: webLeadData.ContactEmail,
                Mobile: webLeadData.ContactMobile,
                WorkPhone: webLeadData.ContactWorkPh,
                HomePhone: webLeadData.ContactHomePh,
                MembershipNumber: webLeadData.CostcoLead?.MembershipNumber,
                Address: leadAddress
            });

            if (!accentUtils.isNull(webLeadData.Address)) {
                data.setSiteAddress(webLeadData.Address);
            }

            showWizardModel(new newLeadWizardModel({ data: data, defaultPageIndex: 1 }), true);

        }

    }

    useExisting(contactID) {

        var me = this;

        if (!accentUtils.isNull(this.state.active)) {

            var lead = this.state.active;

            var notes = this.getCustomPropertiesNotes(lead);


            query_NewLead_LoadContact.getFirstOrDefault({ contactID: contactID }).then(function (details) {

                var webLeadData = JSON.parse(lead.LeadData);
                var data = new NewLeadWizardData({ WebLead: { ExternalLeadID: lead.ID, ExternalLeadDate: lead.Date, ...webLeadData, CostcoLeadID: lead.CostcoLeadID } });


                data.setBillingContact(details.BillingContact);
                data.setJobContact(details.JobContact);

                if (!accentUtils.isNull(webLeadData.Address)) {
                    data.setSiteAddress(webLeadData.Address);
                }

                if (!accentUtils.isNull(details.Company)) {
                    data.setBillingCompany(details.Company);
                }



                showWizardModel(new newLeadWizardModel( { data: data, defaultPageIndex: 1 }), true);

            });




            
        }

    }


    snoozeLead() {
        this.showSnoozeDialog();
    }

    discardLead() {

        if (!accentUtils.isNull(this.state.active)) {
            var me = this;

            showDiscardWebLeadDlg(this.state.active.ID).then(r => {
                me.gridCtrl.current.refresh();

                me.setState({ active: null });

            });
        }
    }


    getMatchClassName(isMatch) {

        if (isMatch)
            return "leads-fld-match";

        return "leads-fld";
    }

    loadMatchData(id) {

        var me = this;

        query_Views_Opportunities_LeadMatches.getAll({ id: id }).then(function (res) {
            me.setState({ matchData: res });
        });
    }

    onRefresh() {
        this.gridCtrl.current.refresh();
    }

    getActions() {
        return [{
                title: lastSnoozeShow ? "Hide Snoozed" : "Show Snoozed",
                onClick: this.toggleShowSnooze
            },
            {
                divider: true
            }];
    }
    getQuery(search) {
        return query_Views_Opportunities_WebLeads.getAllAsQueryable({ SearchString: search, IncludeSnoozed: lastSnoozeShow});            
    }

    onGridRefresh() {
        const selected = this.gridCtrl.current.getSelected();

        if (selected.length > 0) {
            this.setState({ active: selected[0] });
            this.loadMatchData(selected[0].ID);
        } else {
            this.setState({ active: null });
        }

    }

    onRowClick(e) {
        this.setState({ active: e.row });

        this.loadMatchData(e.row.ID);
    }


    toggleShowSnooze() {
        lastSnoozeShow = !lastSnoozeShow;

        this.gridCtrl.current.refresh();

        this.forceUpdate();
    }

    render() {
        var me = this;

     

        //var selectedItem = null;
        var actions = null;
        if (!accentUtils.isNull(this.state.active)) {
            var isSnoozed = this.state.active.SnoozeDate != null && new Date(this.state.active.SnoozeDate) < Date();
            //var leadData = JSON.parse(this.state.active.LeadData);
            //selectedItem = <WebLeadDataCtrl key={this.state.active.ID} webLeadData={{ ...leadData, ExternalLeadID: this.state.active.ID }} col={4} />;

            var matchData = null;

            if (me.state.matchData === null) {
                matchData = <Row>
                    <AccentSpinner />
                </Row>;
            } else if (me.state.matchData.length === 0) {
                matchData = <Row>
                    <Col md="12"><label>{t("application_strings.views.leads.leadGrid.noMatches")}</label></Col>
                </Row>;
            } else {
                matchData = me.state.matchData.map(function (m) {
                    return <RTLContactMatchResult model={m} onSelect={me.useExisting} selectTitle="application_strings.views.leads.leadGrid.createExising" />;
                });
            }

            const buttonStyle = {
                minHeight: "70px"
            };

            actions = <Col md="4" className="webLeads-actions">
                <Row>
                    <Col xs="12">
                        <ButtonToolbar className="config-filter">
                            <ButtonGroup className="me-2">
                                <Button color="danger" outline onClick={me.discardLead}>
                                    {t("application_strings.views.leads.leadGrid.discard")}
                                </Button>

                                {isSnoozed && <Button color="info" outline onClick={me.applyWake}>
                                    {t("application_strings.views.leads.leadGrid.wake")}
                                </Button>}
                                {!isSnoozed && <Button color="info" outline onClick={me.snoozeLead}>
                                    {t("application_strings.views.leads.leadGrid.snooze")}
                                    </Button>
                                }
                                <Button color="success" outline onClick={me.newLead}>
                                    {t("application_strings.views.leads.leadGrid.createNew")}
                                </Button>
                            </ButtonGroup>
                        </ButtonToolbar>
                    </Col>
                </Row>
                <Row>
                    <Col md="12"><strong>{t("application_strings.views.leads.leadGrid.matches")}</strong></Col>
                </Row>
                {matchData}
            </Col>;

        }

        var tableStyle = isMobileOnly ? { paddingLeft: "0", paddingRight: "0" } : undefined;

        const sortIconStyle = { fontSize: "10px", color: "darkgrey" };



        const pos = $(".webLeadGrid").offset();
        const offSet = accentUtils.isNull(pos) ? 100 : pos.top;


        return (
            <Col md={12} className="webLeadGrid">
                <Row>
                    <Col md="8" style={tableStyle}>
                            <React.Suspense fallback={<div stlye={{ minHeight: "300px" }}><AccentSpinner /></div>}>
                            <ExternalLeadGrid
                                gridID="DC0F0E74-A45A-4230-98C6-7298AA55A987"
                                onRowClick={this.onRowClick}
                                onRefresh={this.onGridRefresh}
                                query={this.getQuery}
                                getActions={this.getActions}
                                methods={this.gridCtrl}
                                height={isMobileOnly ? 300 : "screen"} />
                            </React.Suspense >
                    </Col>                    
                    {actions}
                </Row >
            </Col >
        );

    }




}

